import style from './ClientUrlBrief.module.scss'
import { useSelector } from 'react-redux';

const ClientUrlBrief = () => {

    const clinicId = useSelector(state => state.auth?.clinic?.id)

    const getClientUrl = () => {
        if (document !== undefined) {
            return document.location.origin + '/#/book/' + clinicId
        }
    }

    const getIframeCode = () => {
        return `<iframe src="${getClientUrl()}" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>`
    }

    const copiedToClipboardAlert = () => {
        new Promise(resolve => setTimeout(resolve, 500)).then(() => {
            alert('Copied to clipboard')
        });
    }

    return (<div className={ style.container }>

        <div className={ style.bookingUrl }>
            <div className={ style.urlHeader }>
                <div>Your Booking Link</div>
                <button onClick={(e) => {
                    navigator.clipboard.writeText(getClientUrl())
                    copiedToClipboardAlert()
                }}>Copy Url</button>
            </div>
            <div>
                <input type="text" value={ getClientUrl() } readOnly />
            </div>
        </div>
        <div className={ style.embedUrl }>
            <div className={ style.urlHeader }>
                <div>Embed in your website</div>
                <button onClick={(e) => {
                    navigator.clipboard.writeText(getIframeCode())
                    copiedToClipboardAlert()
                }}>Copy Code</button>
            </div>
            <div>
                <textarea value={ getIframeCode() } readOnly />
            </div>
        </div>
    </div>)

}

export default ClientUrlBrief;